<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          安道亿联TIR综合物流平台
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/news">主营业务</el-menu-item>
          <el-menu-item index="/product">运价查询</el-menu-item>
          <el-menu-item index="/case">物流工具</el-menu-item>
          <el-menu-item index="/goin">关于我们</el-menu-item>
        </el-menu>
        <div class="contactInfo">
          <div><el-icon name="phone-outline"  style="font-size: 20px; margin:0 5px;"></el-icon> 17318410357</div>
          <div><el-icon name="message" style="font-size: 20px; margin:0 5px;"></el-icon> jiangxinni1@mastery.net.cn</div>
        </div>
      </el-header>
      <el-main>
        <router-view />
         <div class="footer">
        <div class="copyright">
          <span>Copyright © 安道亿联(重庆)供应链管理有限公司 版权所有 | ICP备案号：&nbsp;<a  href="http://beian.miit.gov.cn/" target="_blank"><span style="color: red;">渝ICP备2022003462号-2</span></a></span>
        </div>
      </div>
      </el-main>
     
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
   
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1440px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    img {
      width: 100%;
      line-height: 60px;
    }
    line-height: 60px;
    font-size: 24px;
  }
  .contactInfo {
    line-height: 60px;
    font-size: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .el-menu--horizontal>.el-menu-item {
    font-weight: bolder;
    font-size: 20px;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #409EFF;
    color: #303133;
    font-weight: bolder;
    font-size: 20px;
}
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  overflow: hidden;
  position: relative;
  .copyright {
    height: 30px;
    text-align: center;
    span {
      color:#333;
      line-height: 30px;
    }
  }
}
</style>
